import Linkify from 'linkify-react';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './MessageBody.module.scss';

const SCHEME_REGEX = /^[a-z][a-z0-9+.-]*:/i;

const linkifyOptions = {
  validate: {
    url: (value) => !SCHEME_REGEX.test(value) || /^https?:/i.test(value),
    email: false,
  },
  target: '_blank',
  rel: 'noopener noreferrer',
  className: styles.link,
};

const MessageBody = ({ text, className }) => (
  <div className={className}>
    <Linkify options={linkifyOptions}>{text}</Linkify>
  </div>
);

MessageBody.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
};

MessageBody.defaultProps = {
  text: '',
  className: undefined,
};

export default MessageBody;
